import React, { useCallback, useState } from 'react';
import PropTypes from "prop-types";
import handleRequest from '../utils/handleRequest';
import { getComparator, stableSort } from 'utils/sortable';

const ValuesContext = React.createContext();

const ValuesProvider = (props) => {
  const [values, setValues] = useState([]);

  const fetchAllValues = useCallback(async () => {
    const res = await handleRequest({
      method: 'get',
      url: `/values`,
    });

    if (res?.status === 200) {
      setValues(res.result)
    } else {
      const errorMessage = res?.message || 'An error occurred while retrieving the values';
      console.log('failed to retrieve product. ', errorMessage);    }
  }, []);

  const updateValues = useCallback(async (
    businessUnit, category, specifier, data, onSuccess = () => {}) => {
    const res = await handleRequest({
      method: 'put',
      url: `/values/${businessUnit}/${category}/${specifier}`,
      data
    });

    if (res.status === 200) {
      typeof onSuccess === 'function' && onSuccess();
    } else {
      console.log('failed to update values. ', res.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getValues = useCallback((businessUnit, category, specifier) => {
    const res = values.find(v => {
      return v.business_unit === businessUnit
        && v.category === category
        && v.specifier === specifier;
    })?.values || [];
    return stableSort(res, getComparator('asc', 'index'));
  }, [values]);

  return (
    <ValuesContext.Provider
      value={{
        state: { values },
        actions: { fetchAllValues, getValues, updateValues }
      }}
    >
      {props.children}
    </ValuesContext.Provider>
  );
}

ValuesContext.propTypes = {
  children: PropTypes.element,
};

export { ValuesProvider, ValuesContext };